const p = (n) => {
  const o = n.match(/clamp\(.+, (.+)\)/);
  return (o == null ? void 0 : o[1]) || n;
}, e = (n, o = []) => Object.fromEntries(
  Object.entries(n).reduce((i, [t, a]) => [
    ...i,
    ...o.map(([r, l]) => [
      `.${r}-${t}`,
      Object.fromEntries(
        l.map((s) => [s, p(a)])
      )
    ])
  ], [])
), g = ({ addBase: n, addComponents: o, addUtilities: i, theme: t }) => {
  const a = e(t("fontSize"), [
    ["text", ["fontSize"]]
  ]), r = e(t("spacing"), [["gap", ["gap"]]]), l = e(t("spacing"), [
    ["m", ["margin"]],
    ["mx", ["marginLeft", "marginRight"]],
    ["my", ["marginBottom", "marginTop"]],
    ["mb", ["marginBottom"]],
    ["mt", ["marginTop"]]
  ]), s = e(t("spacing"), [
    ["p", ["padding"]],
    ["px", ["paddingLeft", "paddingRight"]],
    ["py", ["paddingBottom", "paddingTop"]],
    ["pb", ["paddingBottom"]],
    ["pt", ["paddingTop"]]
  ]);
  n({
    "*,*::after,*::before": { boxSizing: "border-box" },
    "*:focus-visible": {
      outline: "3px",
      outlineColor: t("colors.cyan[500]"),
      outlineStyle: "dotted"
    },
    html: {
      "-moz-osx-font-smoothing": "grayscale",
      "-mox-text-size-adjust": "none",
      "-webkit-font-smoothing": "antialiased",
      "-webkit-text-size-adjust": "none",
      scrollPaddingTop: t("spacing[8]"),
      textSizeAdjust: "none"
    },
    "body,h1,h2,h3,h4,p,figure,blockquote,dl,dd": {
      marginBlockEnd: 0
    },
    'ul[role="list"],ol[role="list"]': { listStyle: "none" },
    body: {
      color: t("colors.neutral-900"),
      fontFamily: t("fontFamily.primary"),
      fontSize: t("fontSize.base"),
      lineHeight: 1.5,
      minHeight: "100vh",
      "overscroll-behavior-y": "none"
    },
    "input,button,textarea,select": { font: "inherit" },
    "h1,h2,h3,h4,input,label": {
      lineHeight: 1.1
    },
    "a:not([class])": {
      color: "currentColor",
      textDecorationSkipInk: "auto"
    },
    "img,picture": {
      display: "block",
      maxWidth: "100%"
    },
    "textarea:not([rows])": { minHeight: "10em" },
    ":target": { scrollBlockMargin: "5ex" },
    "a,button": { cursor: "pointer" },
    "[disabled]": { cursor: "not-allowed" },
    "p, h1, h2, h3, h4, h5, h6": {
      "overflow-wrap": "break-word"
    },
    ...a,
    ...r,
    ...l,
    ...s
  }), o({
    ".absolute-center": {
      left: "50%",
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)"
    },
    ".absolute-center-x": {
      left: "50%",
      position: "absolute",
      transform: "translateX(-50%)"
    },
    ".absolute-center-y": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)"
    },
    ".flex-center": {
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    }
  }), i({
    ".backface-hidden": {
      backfaceVisibility: "hidden"
    },
    ".border-inherit": {
      borderColor: "inherit"
    },
    ".container-none": {
      maxWidth: "none",
      margin: "none",
      width: "auto"
    },
    ...["sm", "md", "lg", "xl", "full"].reduce(
      (d, c) => ({
        ...d,
        [`.container-${c}`]: {
          maxWidth: `theme(containerWidth.${c})`,
          margin: "0 auto",
          width: "100%"
        }
      }),
      {}
    )
  });
};
export {
  g as default
};
